import { render, staticRenderFns } from "./report-view-head.vue?vue&type=template&id=35136708&"
import script from "./report-view-head.vue?vue&type=script&lang=js&"
export * from "./report-view-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports